import type { CSSProperties } from "react";
import { tabShellBaseStyle } from "@/components/common/tab-shell";

/**
 * RightPane のファイルタブの外枠スタイル。表示中のタブは本文と同じ背景で繋げ、文字の強調は
 * フォーカス中のグループに限る。表示中でないタブの背景はホバーで変えるため
 * fileTabInactiveClassName に任せる (インラインで指定すると :hover が効かない)。
 */
export function fileTabShellStyle(shown: boolean, focused: boolean): CSSProperties {
	return {
		...tabShellBaseStyle(shown && focused),
		background: shown ? "var(--editor-bg)" : undefined,
		borderRadius: "var(--radius-2) var(--radius-2) 0 0",
		gap: 4,
		padding: "0 8px 0 14px",
		position: "relative",
	};
}

export const fileTabInactiveClassName = "hover:bg-overlay-hover";

/** タブ帯の直下の本文。画像・PDF など背景を持たないプレビューも表示中のタブと同じ色で繋げる。 */
export const fileTabBodyStyle: CSSProperties = { background: "var(--editor-bg)" };

/** アクティブなファイルタブの下端の左右に置き、外向きの角丸で本文と繋げる。 */
export function fileTabFlareStyle(side: "left" | "right"): CSSProperties {
	return {
		position: "absolute",
		bottom: 0,
		[side]: "calc(-1 * var(--radius-2))",
		width: "var(--radius-2)",
		height: "var(--radius-2)",
		zIndex: 1,
		pointerEvents: "none",
		background: `radial-gradient(circle at ${side === "left" ? "0 0" : "100% 0"}, transparent calc(var(--radius-2) - 0.5px), var(--editor-bg) var(--radius-2))`,
	};
}
